export default "__VITE_ASSET__d537de70__"